import {environment} from './environments/environment';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {loadTypes} from "./jackson.module";
import {enableProdMode} from '@angular/core';
import Amplify from '@aws-amplify/core';
import {AppModule} from './app/modules/app/app.module';

if (environment.production) {
  enableProdMode();
}

loadTypes();

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
